import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page } from '../class/status';
import { Dep } from '../class/auth';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-member-upline',
  templateUrl: './member-upline.component.html',
  styleUrls: ['./member-upline.component.css']
})
export class MemberUplineComponent implements OnInit, OnDestroy {

  // 當前使用者資訊
  currentUser: any = {
    id: '',
    name: '選擇使用者',
    avatar: 'assets/dist/img/user.png',
    email: '',
    phone: ''
  };

  // 上線資訊
  uplineInfo: any = {
    name: '尚未選擇使用者',
    avatar: 'assets/dist/img/user.png',
    commission: 0,
    joinDate: '-'
  };

  // 下線列表
  downlineMembers: any[] = [];

  // 歷史下線列表
  historicalDownlineMembers: any[] = [];

  // Lazy Loading 狀態 - 分別追蹤活躍和歷史成員
  activeHasMore: boolean = true;  // 活躍成員是否還有更多數據
  historyHasMore: boolean = true;  // 歷史成員是否還有更多數據
  isLoadingMoreActive: boolean = false;  // 是否正在加載更多活躍成員
  isLoadingMoreHistory: boolean = false;  // 是否正在加載更多歷史成員
  activePage: number = 1;  // 活躍成員當前頁碼（第0頁在init時加載）
  historyPage: number = 1;  // 歷史成員當前頁碼
  activeTotalCount: number = 0;  // 活躍成員總數
  historyTotalCount: number = 0;  // 歷史成員總數

  // Modal 控制
  showAddModal: boolean = false;
  showEditModal: boolean = false;
  showDeleteModal: boolean = false;
  showHistoryModal: boolean = false;
  showRevenueModal: boolean = false;

  // 標記是否為歷史成員（用於禁用編輯）
  isHistoricalMember: boolean = false;

  // 表單資料
  editData: any = {
    user_id: '',
    parent_user_id: '',
    name: '',
    avatar: '',
    status: 1,
    joinDate: ''
  };

  // 待刪除的成員
  deleteTarget: any = null;

  // 歷史紀錄
  selectedMember: any = null;
  editHistory: any[] = [];

  // 收益資料
  revenueData: any = {
    totalRevenue: 0,
    monthlyRevenue: 0,
    revenueHistory: []
  };

  // 收益顯示模式：'daily' 或 'monthly'
  revenueViewMode: 'daily' | 'monthly' = 'monthly';

  // 原始日收益數據（從後端獲取）
  dailyRevenueData: any[] = [];

  // 下線收益統計
  totalRevenue: number = 0;      // 累積總收益（history_reward）
  monthlyRevenue: number = 0;    // 本月收益（month_reward）
  todayRevenue: number = 0;      // 本日總收益（today_reward）

  // 搜尋相關
  searchQuery: string = '';
  userList: any[] = [];
  filteredUserList: any[] = [];
  selectedUser: any = null;

  // 下線列表搜尋
  downlineSearchQuery: string = '';
  private searchSubject$ = new Subject<string>();

  // 頂部搜尋使用者
  topSearchQuery: string = '';
  topSearchResults: any[] = [];
  showTopSearchResults: boolean = false;

  pageobj: page = { page: 0, count: 20, total_count: 0 };  // 每頁 20 筆
  loading: boolean = false;

  constructor(public httpClient: HttpClient) { }

  ngOnInit(): void {
    // 不預設載入任何使用者，等待使用者透過搜尋框選擇
    Dep.getData(); // 確保登入資訊已載入

    // 監聽搜尋輸入，延遲 500ms 後發送請求（防抖）
    this.searchSubject$.pipe(
      debounceTime(500),           // 延遲 500ms
      distinctUntilChanged()        // 只有當值真正改變時才觸發
    ).subscribe(searchQuery => {
      console.log('搜尋關鍵字:', searchQuery);
      // 重新載入列表（帶搜尋參數）
      this.loadInitialData();
    });
  }

  ngOnDestroy(): void {
    // 組件銷毀時取消訂閱
    this.searchSubject$.complete();
  }

  // 當搜尋框輸入改變時調用
  onSearchQueryChange(query: string) {
    this.downlineSearchQuery = query;
    this.searchSubject$.next(query);
  }


  // 初始化下線列表（重置並加載第一頁）
  init_list() {
    console.log('開始載入下線列表...');
    this.loading = true;

    // 確保使用者 ID 存在
    const userId = this.currentUser.id;
    console.log('使用者 ID:', userId);

    if (!userId) {
      console.warn('使用者 ID 不存在，無法載入下線列表');
      this.loading = false;
      return;
    }

    // 重置所有狀態
    this.downlineMembers = [];
    this.historicalDownlineMembers = [];
    this.activePage = 1;
    this.historyPage = 1;
    this.activeHasMore = true;
    this.historyHasMore = true;
    this.activeTotalCount = 0;
    this.historyTotalCount = 0;

    // 加載第一頁數據（action = 0）
    this.loadInitialData();
  }

  // 加載初始數據（action = 0）
  loadInitialData() {
    const userId = this.currentUser.id;

    if (!userId) {
      console.warn('使用者 ID 不存在，無法載入下線列表');
      this.loading = false;
      return;
    }

    this.loading = true;

    const body: any = {
      action: 0,  // 第一次加載
      parent_user_id: userId,
    };

    // 如果有搜尋關鍵字，添加到請求中
    if (this.downlineSearchQuery.trim()) {
      body.search_query = this.downlineSearchQuery.trim();
    }

    console.log('準備發送 API 請求 (action=0):', body);

    this.httpClient.post<any>("/get_member_downline.php", body).subscribe(
      res => {
        this.loading = false;

        if (res.status && res.data) {
          // 活躍下線成員
          this.downlineMembers = res.data.downline || [];
          this.activeTotalCount = res.data.active_total_count || 0;
          this.activeHasMore = res.data.active_has_more || false;

          // 歷史下線成員
          this.historicalDownlineMembers = res.data.history_downline || [];
          this.historyTotalCount = res.data.history_total_count || 0;
          this.historyHasMore = res.data.history_has_more || false;

          console.log('初始數據加載完成:', {
            活躍成員: this.downlineMembers.length + '/' + this.activeTotalCount,
            歷史成員: this.historicalDownlineMembers.length + '/' + this.historyTotalCount
          });

          // 設定收益統計（從後端獲取）
          this.totalRevenue = parseFloat(res.data.history_reward) || 0;            // 累積總收益（NT$）
          this.monthlyRevenue = parseFloat(res.data.month_reward) || 0;            // 本月收益（NT$）
          this.todayRevenue = (parseFloat(res.data.today_reward) || 0) / 100;      // 本日總收益（鑽石，需除以 100）

          console.log('收益統計數據:', {
            累積總收益: this.totalRevenue,
            本月收益: this.monthlyRevenue,
            本日總收益: this.todayRevenue
          });

          // 設定上線資訊
          if (res.data.upline && res.data.upline.length > 0) {
            const upline = res.data.upline[0];
            this.uplineInfo = {
              id: upline.downlineId || '-1',
              name: upline.uplineName || upline.name || '無上線',
              avatar: upline.uplineProfilePic || upline.profile_pic || 'assets/dist/img/user.png',
              commission: upline.uplinePercent || 0,
              joinDate: upline.uplineCreateDT || upline.createDT || '-'
            };
          } else {
            this.uplineInfo = {
              name: '無上線',
              avatar: 'assets/dist/img/user.png',
              commission: 0,
              joinDate: '-'
            };
          }
        } else {
          this.downlineMembers = [];
          this.historicalDownlineMembers = [];
        }
      },
      error => {
        this.loading = false;
        console.error('API 錯誤:', error);
        alert('載入失敗，請稍後再試');
      }
    );
  }

  // 加載更多活躍成員（action = 1）
  loadMoreActiveMembers() {
    if (!this.activeHasMore || this.isLoadingMoreActive) {
      console.log('無法加載更多活躍成員');
      return;
    }

    this.isLoadingMoreActive = true;

    const body: any = {
      action: 1,  // 加載活躍下線
      parent_user_id: this.currentUser.id,
      page: this.activePage,
      limit: 9
    };

    // 如果有搜尋關鍵字，添加到請求中
    if (this.downlineSearchQuery.trim()) {
      body.search_query = this.downlineSearchQuery.trim();
    }

    console.log('準備發送 API 請求 (action=1):', body);

    this.httpClient.post<any>("/get_member_downline.php", body).subscribe(
      res => {
        this.isLoadingMoreActive = false;

        if (res.status && res.data) {
          const newMembers = res.data.downline || [];
          this.downlineMembers = [...this.downlineMembers, ...newMembers];
          this.activeHasMore = res.data.has_more || false;
          this.activePage++;

          console.log('活躍成員加載更多:', this.downlineMembers.length + '/' + this.activeTotalCount);
        }
      },
      error => {
        this.isLoadingMoreActive = false;
        console.error('API 錯誤:', error);
        alert('載入失敗，請稍後再試');
      }
    );
  }

  // 加載更多歷史成員（action = 2）
  loadMoreHistoryMembers() {
    if (!this.historyHasMore || this.isLoadingMoreHistory) {
      console.log('無法加載更多歷史成員');
      return;
    }

    this.isLoadingMoreHistory = true;

    const body: any = {
      action: 2,  // 加載歷史下線
      parent_user_id: this.currentUser.id,
      page: this.historyPage,
      limit: 9
    };

    // 如果有搜尋關鍵字，添加到請求中
    if (this.downlineSearchQuery.trim()) {
      body.search_query = this.downlineSearchQuery.trim();
    }

    console.log('準備發送 API 請求 (action=2):', body);

    this.httpClient.post<any>("/get_member_downline.php", body).subscribe(
      res => {
        this.isLoadingMoreHistory = false;

        if (res.status && res.data) {
          const newMembers = res.data.history_downline || [];
          this.historicalDownlineMembers = [...this.historicalDownlineMembers, ...newMembers];
          this.historyHasMore = res.data.has_more || false;
          this.historyPage++;

          console.log('歷史成員加載更多:', this.historicalDownlineMembers.length + '/' + this.historyTotalCount);
        }
      },
      error => {
        this.isLoadingMoreHistory = false;
        console.error('API 錯誤:', error);
        alert('載入失敗，請稍後再試');
      }
    );
  }

  // 開啟新增 Modal
  openAddModal() {
    this.editData = {
      id: '',
      name: '',
      avatar: '',
      commission: 5.0,
      status: 1,
      joinDate: new Date().toISOString().split('T')[0]
    };
    this.searchQuery = '';
    this.filteredUserList = [];
    this.selectedUser = null;
    this.showAddModal = true;
  }

  // 關閉新增 Modal
  closeAddModal() {
    this.showAddModal = false;
    this.searchQuery = '';
    this.filteredUserList = [];
    this.selectedUser = null;
  }

  // === 頂部搜尋使用者相關方法 ===

  // 頂部搜尋使用者（切換查看不同使用者的下線）
  searchTopUsers() {
    if (this.topSearchQuery.trim() === '') {
      this.topSearchResults = [];
      this.showTopSearchResults = false;
      return;
    }

    this.httpClient.post<any>("/get_searchuser_list.php", { query: this.topSearchQuery }).subscribe(
      res => {
        if (res.status && res.data) {
          this.topSearchResults = res.data;
          this.showTopSearchResults = true;
        }
      },
      error => {
        console.error('搜尋使用者失敗:', error);
      }
    );
  }

  // 選擇使用者並切換視角
  switchToUser(user: any) {
    this.currentUser = {
      id: user.id,
      name: user.name || user.nickname,
      phone: user.phone || '',
      email: user.email || '',
      avatar: user.profile_pic || user.avatar || 'https://i.pravatar.cc/150?img=12'
    };

    console.log('切換到使用者:', this.currentUser);

    // 清空搜尋
    this.topSearchQuery = user.name || user.nickname;
    this.topSearchResults = [];
    this.showTopSearchResults = false;

    // 載入下線列表（同時會載入上線資訊）
    this.init_list();
  }

  // 清除頂部搜尋
  clearTopSearch() {
    this.topSearchQuery = '';
    this.topSearchResults = [];
    this.showTopSearchResults = false;
  }

  // 切換到上線
  switchToUpline() {
    // 檢查是否有上線資訊
    if (!this.uplineInfo.id || this.uplineInfo.id === '-1') {
      console.log('無上線資訊，無法切換');
      return;
    }

    console.log('切換到上線:', this.uplineInfo);

    // 使用上線資訊切換視角
    this.currentUser = {
      id: this.uplineInfo.id,
      name: this.uplineInfo.name,
      phone: '',
      email: '',
      avatar: this.uplineInfo.avatar
    };

    // 更新搜尋框
    this.topSearchQuery = this.uplineInfo.name;
    this.topSearchResults = [];
    this.showTopSearchResults = false;

    // 重新載入下線列表
    this.init_list();
  }

  // 計算收益統計
  calculateRevenueStats(downlineMembers: any[]) {
    // 從下線成員資料中計算總收益和本月收益
    let total = 0;
    let monthly = 0;

    downlineMembers.forEach((member: any) => {
      // 嘗試多種可能的欄位名稱來取得收益資料
      const memberTotal = parseFloat(
        member.totalRevenue ||
        member.total_revenue ||
        member.累積總收益 ||
        member.total ||
        0
      );

      const memberMonthly = parseFloat(
        member.monthlyRevenue ||
        member.monthly_revenue ||
        member.本月收益 ||
        member.dailyRevenue ||
        member.daily_revenue ||
        member.monthly ||
        0
      );

      total += memberTotal;
      monthly += memberMonthly;

      // 輸出每個成員的收益資料以便調試
      if (memberTotal > 0 || memberMonthly > 0) {
        console.log(`成員 ${member.downlineName}: 總收益=${memberTotal}, 本月收益=${memberMonthly}`);
      }
    });

    this.totalRevenue = total;
    this.monthlyRevenue = monthly;

    console.log('收益統計總計:', {
      totalRevenue: this.totalRevenue,
      monthlyRevenue: this.monthlyRevenue,
      成員數量: downlineMembers.length
    });
  }

  // === Modal 中新增成員的搜尋方法 ===

  // 搜尋用戶
  searchUsers() {
    if (this.searchQuery.trim() === '') {
      this.filteredUserList = [];
      return;
    }

    // 實際 API 呼叫：
    this.httpClient.post<any>("/get_searchuser_list.php", {query: this.searchQuery}).subscribe(res => {
      if (res.status) {
        this.filteredUserList = res.data;
      }
    });

  }

  // 選擇用戶
  selectUser(user: any) {
    this.selectedUser = user;
    this.editData.name = user.name;
    this.editData.avatar = user.profile_pic;
    this.searchQuery = user.name;
    this.filteredUserList = [];
  }

  // 清除選擇
  clearSelection() {
    this.selectedUser = null;
    this.searchQuery = '';
    this.filteredUserList = [];
    this.editData.name = '';
    this.editData.avatar = '';
  }

  // 確認新增
  confirmAdd() {
    if (!this.selectedUser) {
      alert('請先選擇要新增的成員');
      return;
    }

    // 驗證分潤比例
    const commission = parseFloat(this.editData.commission);
    if (isNaN(commission) || commission < 3 || commission > 40) {
      alert('分潤比例必須在 3% ~ 40% 之間，請重新輸入');
      return;
    }

    console.log('新增下線成員', this.editData);
    console.log('準備發送 API 請求:', {
      action: 1,
      user_id: this.selectedUser.id,
      parent_user_id: this.currentUser.id,
      percent: this.editData.commission,
      join_date: this.editData.joinDate,
    });

    // 實際 API 呼叫：
    this.httpClient.post<any>("/set_member_downline.php", {
      action: 1,
      user_id: this.selectedUser.id,
      parent_user_id: this.currentUser.id,
      percent: this.editData.commission,
      join_date: this.editData.joinDate,
    }).subscribe(res => {
      console.log('API 回應:', res);
      if (res.status) {
        this.init_list();
        this.closeAddModal();
      } else {
        // 顯示錯誤訊息
        alert(res.message || '操作失敗，請稍後再試');
      }
    });
  }

  // 開啟編輯 Modal
  openEditModal(member: any, event?: Event) {
    // 阻止事件冒泡
    if (event) {
      event.stopPropagation();
    }

    console.log('openEditModal 參數 member:', member);
    // 防禦性檢查
    if (!member) {
      console.error('openEditModal: member is null or undefined');
      return;
    }

    console.log('開啟編輯 Modal，成員資料:', member);

    // 映射 API 返回的欄位名稱到 editData 使用的欄位名稱
    const joinDate = member.downlineCreateDT || member.createDT || member.create_dt || '';
    // 如果日期包含時間，只取日期部分 (YYYY-MM-DD)
    const formattedDate = joinDate ? joinDate.split(' ')[0] : '';

    this.editData = {
      id: member.downlineId || member.id || member.user_id,
      name: member.downlineName || member.name,
      avatar: member.downlineProfilePic || member.profile_pic || 'https://i.pravatar.cc/150?img=12',
      commission: member.downlinePercent || member.percent || 0,
      joinDate: formattedDate,
      status: member.status !== undefined ? member.status : 1
    };

    // 判斷是否為歷史成員（downlineStatus != 1）
    this.isHistoricalMember = member.downlineStatus != 1;

    console.log('編輯資料:', this.editData);
    console.log('是否為歷史成員:', this.isHistoricalMember);
    this.showEditModal = true;
  }

  // 關閉編輯 Modal
  closeEditModal() {
    this.showEditModal = false;
    this.isHistoricalMember = false;
  }

  // 確認編輯
  confirmEdit() {
    // 驗證分潤比例
    const commission = parseFloat(this.editData.commission);
    if (isNaN(commission) || commission < 3 || commission > 40) {
      alert('分潤比例必須在 3% ~ 40% 之間，請重新輸入');
      return;
    }

    console.log('編輯成員', this.editData);
    console.log('準備發送 API 請求:', {
      action: 2,
      percent: this.editData.commission,
      user_id: this.editData.id,
      parent_user_id: this.currentUser.id,
    });

    // 實際 API 呼叫：
    this.httpClient.post<any>("/set_member_downline.php", {
      action: 2,
      percent: this.editData.commission,
      user_id: this.editData.id,
      parent_user_id: this.currentUser.id,
    }).subscribe(res => {
      console.log('API 回應:', res);
      if (res.status) {
        this.init_list();
        this.closeEditModal();
      } else {
        // 顯示錯誤訊息
        alert(res.message || '操作失敗，請稍後再試');
      }
    });
  }

  // 開啟刪除確認 Modal
  openDeleteModal(member: any) {
    this.deleteTarget = member;
    this.showDeleteModal = true;
  }

  // 關閉刪除 Modal
  closeDeleteModal() {
    this.showDeleteModal = false;
    this.deleteTarget = null;
  }

  // 確認刪除
  confirmDelete() {
    console.log('刪除成員', this.deleteTarget);
    console.log('準備發送 API 請求:', {
      action: 3,
      user_id: this.deleteTarget.downlineId || this.deleteTarget.id,
      parent_user_id: this.currentUser.id,
    });

    // 實際 API 呼叫：
    this.httpClient.post<any>("/set_member_downline.php", {
      action: 3,
      user_id: this.deleteTarget.downlineId || this.deleteTarget.id,
      parent_user_id: this.currentUser.id,
    }).subscribe(res => {
      console.log('API 回應:', res);
      if (res.status) {
        this.init_list();
        this.closeDeleteModal();
      } else {
        // 顯示錯誤訊息
        alert(res.message || '刪除失敗，請稍後再試');
      }
    });
  }

  // 查看歷史編輯紀錄
  viewHistory(member: any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.selectedMember = member;
    this.loadEditHistory(member);
    this.showHistoryModal = true;
  }

  // 關閉歷史紀錄 Modal
  closeHistoryModal() {
    this.showHistoryModal = false;
    this.selectedMember = null;
    this.editHistory = [];
  }

  // 載入編輯歷史紀錄
  loadEditHistory(member: any) {
    console.log('載入編輯歷史紀錄:', member);

    // 準備 API 參數
    const params = {
      action: 0,  // 第一次加載歷史紀錄
      user_id: member.downlineId || member.id || member.user_id,
      create_dt: member.downlineCreateDT || member.create_dt,
      end_dt: member.downlineEndDT || member.end_dt || ''
    };

    console.log('準備發送 API 請求 (get_member_downline_log.php):', params);

    // 實際 API 呼叫
    this.httpClient.post<any>("/get_member_downline_log.php", params).subscribe(res => {
      console.log('API 回應:', res);
      if (res.status && res.data) {
        // 轉換後端資料為前端顯示格式
        this.editHistory = this.transformLogData(res.data);
      } else {
        this.editHistory = [];
      }
    }, error => {
      console.error('載入編輯歷史失敗:', error);
      this.editHistory = [];
    });
  }

  // 轉換後端日誌資料為前端顯示格式
  transformLogData(logData: any[]): any[] {
    return logData.map((log: any, index: number) => {
      let actionText = '';
      let field = '';
      let oldValue = '';
      let newValue = '';

      // 根據 action 類型設定顯示內容
      switch (log.action) {
        case 1:
        case '1':
          actionText = '新增下線成員';
          field = '新增成員';
          oldValue = '-';
          newValue = `分潤比例 ${log.percent}%`;
          break;
        case 2:
        case '2':
          actionText = '修改分潤比例';
          field = '修改分潤比例';
          // 尋找上一次操作的 percent 值作為 oldValue
          if (index < logData.length) {
            const previousLog = logData[index - 1];
            if (previousLog && previousLog.percent) {
              oldValue = `${previousLog.percent}%`;
            } else {
              oldValue = '-';
            }
          } else {
            oldValue = '-';
          }
          newValue = `${log.percent}%`;
          break;
        case 3:
        case '3':
          actionText = '刪除下線成員';
          field = '操作類型';
          oldValue = '-';
          newValue = '刪除成員';
          break;
        default:
          actionText = '未知操作';
          field = '操作';
          oldValue = '-';
          newValue = '-';
      }

      return {
        id: index + 1,
        editTime: log.create_dt || log.editTime || '-',
        editor: log.employeeName || '系統',
        field: field,
        oldValue: oldValue,
        newValue: newValue,
        action: log.action,
        percent: log.percent
      };
    });
  }

  // 生成模擬歷史紀錄
  generateMockHistory(memberId: number): any[] {
    const editors = ['王小明', '張經理', '李主管', '陳助理'];
    const actions = [
      { field: 'commission', label: '分潤比例', oldValue: '4.5%', newValue: '5.5%' },
      { field: 'status', label: '狀態', oldValue: '停用', newValue: '活躍' },
      { field: 'name', label: '成員名稱', oldValue: '李小華(舊)', newValue: '李小華' },
      { field: 'commission', label: '分潤比例', oldValue: '3.0%', newValue: '4.5%' },
      { field: 'status', label: '狀態', oldValue: '活躍', newValue: '停用' },
      { field: 'commission', label: '分潤比例', oldValue: '5.5%', newValue: '6.0%' },
    ];

    const history = [];
    const recordCount = Math.floor(Math.random() * 5) + 2; // 2-6 筆紀錄

    for (let i = 0; i < recordCount; i++) {
      const daysAgo = Math.floor(Math.random() * 60) + 1;
      const date = new Date();
      date.setDate(date.getDate() - daysAgo);

      const action = actions[Math.floor(Math.random() * actions.length)];

      history.push({
        id: i + 1,
        editTime: date.toISOString().split('T')[0] + ' ' +
                  (Math.floor(Math.random() * 12) + 8).toString().padStart(2, '0') + ':' +
                  Math.floor(Math.random() * 60).toString().padStart(2, '0'),
        editor: editors[Math.floor(Math.random() * editors.length)],
        field: action.label,
        oldValue: action.oldValue,
        newValue: action.newValue,
        description: `將 ${action.label} 從「${action.oldValue}」修改為「${action.newValue}」`
      });
    }

    return history.sort((a, b) => new Date(b.editTime).getTime() - new Date(a.editTime).getTime());
  }

  // 點擊卡片查看收益詳情
  onCardClick(member: any, event: Event) {
    // console.log('點擊卡片，成員資料:', member);
    // 確保點擊的不是編輯按鈕
    const target = event.target as HTMLElement;
    if (!target.closest('.btn-action')) {
      this.viewRevenue(member);
    }
  }

  // 查看收益詳情
  viewRevenue(member: any) {
    this.selectedMember = member;
    // console.log('查看收益詳情，成員資料:', member);
    this.loadRevenueData(member.downlineId);
    this.showRevenueModal = true;
  }

  // 關閉收益詳情 Modal
  closeRevenueModal() {
    this.showRevenueModal = false;
    this.selectedMember = null;
    this.revenueData = {
      totalRevenue: 0,
      monthlyRevenue: 0,
      revenueHistory: []
    };
  }

  // 載入收益資料
  loadRevenueData(memberId: number) {
    console.log('載入收益資料，成員 ID:', memberId);

    // 重置顯示模式為月份
    this.revenueViewMode = 'monthly';

    const params = {
      action: 1,  // 查詢該成員的歷史收益
      user_id: memberId
    };

    console.log('準備發送 API 請求 (get_member_downline_log.php, action=1):', params);

    this.httpClient.post<any>("/get_member_downline_log.php", params).subscribe(
      res => {
        console.log('API 回應:', res);
        if (res.status && res.data) {
          // 儲存原始日數據
          this.dailyRevenueData = res.data;

          // 計算總收益和本月收益
          this.calculateMemberRevenueStats();

          // 根據當前顯示模式更新顯示數據
          this.updateRevenueDisplay();
        } else {
          this.dailyRevenueData = [];
          this.revenueData = {
            totalRevenue: 0,
            monthlyRevenue: 0,
            revenueHistory: []
          };
        }
      },
      error => {
        console.error('載入收益資料失敗:', error);
        this.dailyRevenueData = [];
        this.revenueData = {
          totalRevenue: 0,
          monthlyRevenue: 0,
          revenueHistory: []
        };
      }
    );
  }

  // 計算單個成員的收益統計（用於收益詳情 Modal）
  calculateMemberRevenueStats() {
    if (!this.dailyRevenueData || this.dailyRevenueData.length === 0) {
      this.revenueData.totalRevenue = 0;
      this.revenueData.monthlyRevenue = 0;
      return;
    }

    // 計算總收益
    const total = this.dailyRevenueData.reduce((sum, item) => {
      return sum + (parseFloat(item.reward) || 0);
    }, 0);

    // 計算本月收益
    const currentMonth = new Date().toISOString().slice(0, 7); // 格式：YYYY-MM
    const monthlyTotal = this.dailyRevenueData
      .filter(item => item.date && item.date.startsWith(currentMonth))
      .reduce((sum, item) => sum + (parseFloat(item.reward) || 0), 0);

    this.revenueData.totalRevenue = total;
    this.revenueData.monthlyRevenue = monthlyTotal;

    console.log('成員收益統計:', {
      總收益: total,
      本月收益: monthlyTotal,
      數據筆數: this.dailyRevenueData.length
    });
  }

  // 更新收益顯示（根據當前顯示模式）
  updateRevenueDisplay() {
    if (this.revenueViewMode === 'monthly') {
      // 按月顯示
      this.revenueData.revenueHistory = this.aggregateByMonth();
    } else {
      // 按日顯示（過濾掉無效數據）
      this.revenueData.revenueHistory = this.dailyRevenueData
        .filter(item => item.date && item.reward)  // ← 只保留有 date 和 reward 的數據
        .map(item => ({
          date: item.date,
          revenue: parseFloat(item.reward) || 0
        }))
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
    }

    console.log('更新顯示模式:', this.revenueViewMode, '數據筆數:', this.revenueData.revenueHistory.length);
  }

  // 將日數據聚合成月數據
  aggregateByMonth(): any[] {
    const monthlyMap: { [key: string]: number } = {};

    // 聚合數據（過濾掉無效數據）
    this.dailyRevenueData
      .filter(item => item.date && item.reward)  // ← 只保留有 date 和 reward 的數據
      .forEach(item => {
        const month = item.date.slice(0, 7); // 取 YYYY-MM
        const reward = parseFloat(item.reward) || 0;
        monthlyMap[month] = (monthlyMap[month] || 0) + reward;
      });

    // 轉換成陣列並排序
    const monthlyArray = Object.keys(monthlyMap).map(month => ({
      month: month,
      revenue: monthlyMap[month]
    })).sort((a, b) => b.month.localeCompare(a.month)); // 新的月份在前

    console.log('月份聚合結果:', monthlyArray);
    return monthlyArray;
  }

  // 切換顯示模式（日/月）
  toggleRevenueViewMode(mode: 'daily' | 'monthly') {
    this.revenueViewMode = mode;
    this.updateRevenueDisplay();
  }

  // 生成模擬收益資料
  generateMockRevenue(memberId: number): any {
    const months = ['2024-09', '2024-10', '2024-11', '2024-12', '2025-01'];
    const history = [];
    let total = 0;

    for (let i = 0; i < months.length; i++) {
      const revenue = Math.floor(Math.random() * 50000) + 10000;
      total += revenue;
      history.push({
        month: months[i],
        revenue: revenue,
        transactions: Math.floor(Math.random() * 100) + 20
      });
    }

    return {
      totalRevenue: total,
      monthlyRevenue: history[history.length - 1].revenue,
      revenueHistory: history.reverse()
    };
  }

  // 從收益詳情開啟編輯
  openEditFromRevenue() {
    const member = this.selectedMember;  // 先保存到局部變量
    this.closeRevenueModal();  // 再關閉 Modal（會清空 selectedMember）
    this.openEditModal(member);  // 使用保存的值
  }

  // 從收益詳情查看歷史
  viewHistoryFromRevenue() {
    const member = this.selectedMember;
    this.closeRevenueModal();
    this.viewHistory(member);
  }

  // 從收益詳情切換到該成員視角
  switchToMemberFromRevenue() {
    if (!this.selectedMember) {
      return;
    }

    // 取得成員 ID 和資訊
    const memberId = this.selectedMember.downlineId || this.selectedMember.id;
    const memberName = this.selectedMember.downlineName || this.selectedMember.name;
    const memberAvatar = this.selectedMember.downlineProfilePic || this.selectedMember.profile_pic || 'assets/dist/img/user.png';

    console.log('從收益詳情切換到成員:', memberName, 'ID:', memberId);

    // 關閉 Modal
    this.closeRevenueModal();

    // 更新當前使用者
    this.currentUser = {
      id: memberId,
      name: memberName,
      phone: '',
      email: '',
      avatar: memberAvatar
    };

    // 更新搜尋框
    this.topSearchQuery = memberName;
    this.topSearchResults = [];
    this.showTopSearchResults = false;

    // 重新載入下線列表
    this.init_list();
  }

  // 分頁回調
  callback(pageobj: page) {
    if (JSON.stringify(this.pageobj) != JSON.stringify(pageobj)) {
      this.pageobj = pageobj;
      this.init_list();
    }
  }
}
